// extracted by mini-css-extract-plugin
export var container = "_be-0";
export var containerTopRight = "_be-1";